import { mapState } from "vuex";
import AppFooter from "../pagecomp/appFooter";
import AppHeader from "../pagecomp/appHeader";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { mapGetters } from "vuex";
import axios from "axios";
import Loading from "@/components/lib/loading";

import { apiClient } from "@/utils/apiClient";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import DatePicker from 'vue2-datepicker';


requestApp = {
  props: ["beneCode","lg"],
  components: {
    AppFooter,
    AppHeader,
    vueDropzone: vue2Dropzone,
    DatePicker,
  },
  name: "requestMain",
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus"]),
    loading: function() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    },

    dynamicBene() {
      const beneCode = localStorage.getItem("beneGroup");
      const lgType = localStorage.getItem("lgType");
      console.log(beneCode+"  :  "+lgType);
      // const beName = this.beneCode
      //if (beneCode === undefined) {
      //  return () => import(`@/components/request/default`);
      //}

      return () => import(`@/components/request/${beneCode}_${lgType}`);
      // return () => import(`@/components/request/default`);
    }

  },
  methods: {
    getLgTypeList: function() {
      //console.log("taxid:"+taxid);
      apiClient.get("/api/home/getBeneficiaryProfile/"+beneficiary.beneTaxId).then(resp => {
        this.custLgTypeList = resp.data;
      });
    },

    checkReqType: function(type){
      if(type=="NEW" && this.reqTypeNew=="accepted"){
        this.reqTypeExt = "not_accepted";
        this.reqTypeInc = "not_accepted";
      }

      if((type=="EXT" || type=="INC") && this.reqTypeNew=="accepted"){
        this.reqTypeExt = "not_accepted";
        this.reqTypeInc = "not_accepted";
      }

      //alert("checkReqType : "+type);
    },

    imageRemoved(file, error, xhr) {
      alert("test");
    },
    saveRequest: function(){
      const{reqNo,reqTypeNew,reqTypeExt,reqTypeInc} = this;
      
      //var reqType = "";
      if(this.reqTypeNew=='accepted'){
          this.reqType = "NEW";
      }else{
        if(this.reqTypeExt=='accepted'){
          this.reqType = "EXT";
        }
        if(this.reqTypeExt=='accepted'){
          if(this.reqType==''){
            this.reqType = "INC";
          }else{
            this.reqType = this.reqType+"-INC";
          }          
        }
      }

      //set periodStartDate
      if(this.periodType=="1")
        this.periodStartDate = this.periodStartDate1;
      else
        this.periodStartDate = this.periodStartDate2;

      console.log("reqType : "+this.reqType);
      if(this.reqType==""){
        alert("กรุณาเลือกประเภทการขอออกหนังสือค้ำประกัน");
        return false;
      }else{
        alert("reqType:"+this.reqType+",lgType:"+this.lgType);
        apiClient.post("/api/elg/request/"+localStorage.getItem("registerVerifyId"), 
        { 
          reqNo: reqNo,
          status: "PS",
          reqType: this.reqType,
          cifNo: localStorage.getItem("cifNo"),
          requesterTaxId: this.appVo.requesterTaxId,
          requesterNameTh: this.appVo.requesterNameTh,
          requesterNameEn: this.appVo.requesterNameEn,
          beneTaxId: this.beneficiary.beneTaxId,
          contingentTypeId: this.lgType,
          lgAmt: this.lgAmt,
          periodType: this.periodType,
          periodStartDate: this.periodStartDate

        }).then(resp => {
          // if(resp.data.code=='0000'){//success
          //     //alert msg บันทึกข้อมูลเรียบร้อย
          //     alert("บันทึกข้อมูลเรียบร้อย");
          //     this.$router.push("/firstPageReg");
          // }
        });

      }
      
      /*apiClient.post("/api/customer/contractBack/"+localStorage.getItem("registerVerifyId"), 
      { 
        email: this.email, 
        telNo: this.telNo
      }).then(resp => {
        if(resp.data.code=='0000'){//success
            //alert msg บันทึกข้อมูลเรียบร้อย
            alert("บันทึกข้อมูลเรียบร้อย");
            this.$router.push("/firstPageReg");
        }
      });*/
    }
  },
  data() {
    return {
      reqNo:"",
      reqType:"",
      reqTypeNew:"",
      reqTypeExt:"",
      reqTypeInc:"",
      appVo: [],
      beneficiary:{ beneTaxId: localStorage.getItem("beneTaxId"), beneGroup: localStorage.getItem("beneGroup")},
      beneficiaryList: [],
      lgType:localStorage.getItem("lgType"),
      custLgTypeList: [],
      commList: [],//[{"commNo":"10000010000","amt":"10000000.00"},{"commNo":"10000020000","amt":"20000000.00"}],
      periodType:"",
      status1:"",
      status2:"",
      status3:"",
      accountNo:"",
      majorStampAmt:"",
      minorStampAmt:"",
      dutyStampAmt:"",
      periodStartDate:"",
      periodStartDate1:"",
      periodStartDate2:"",
      periodEndDate:"",
      lgAmt:"",
      
      
      dropzoneOptions: {
        url: "http://10.28.103.83:8080/api/customer/upload",
        thumbnailWidth: 150,
        maxFilesize: 3,
        addRemoveLinks: true,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
          "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + this.$store.state.auth.token//localStorage.getItem("user-token")
        },
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>UPLOAD ME",
        acceptedFiles: "image/*,application/pdf"
      }
    };
  },
  mounted() {
    // let tokenStr = localStorage.getItem("user-token");
    localStorage.setItem("cifNo","29956303");
    apiClient.get("/api/elg/defaultRequest/"+this.$route.params.registerVerifyId+"/29956303").then(resp => {
       this.appVo = resp.data;
       this.reqNo = resp.data.reqNo;
       this.commList = resp.data.accountLimit;
       this.majorStampAmt = resp.data.majorStampAmt;
       this.minorStampAmt = resp.data.minorStampAmt;
       this.dutyStampAmt = resp.data.dutyStampAmt;
    });

    apiClient.get("/api/home/getBeneficiary").then(resp => {
      this.beneficiaryList = resp.data;
    });

    apiClient.get("/api/home/getBeneficiaryProfile/"+localStorage.getItem("beneTaxId")).then(resp => {
        this.custLgTypeList = resp.data;
    });

    this.lgAmt = localStorage.getItem("amount");
  },
  
}

export default requestApp